import { getPlatform } from '../platform';
import { PAYZHE_BTP_DEEP_LINK } from './config';

const MOBILE_MAX_WIDTH_PX = 1024;

export function isMobileViewport(): boolean {
  if (typeof globalThis.matchMedia !== 'function') return false;
  return globalThis.matchMedia(`(max-width: ${MOBILE_MAX_WIDTH_PX}px)`).matches;
}

/** payzhe BTP localhost bridge works when Zeettu runs on the same Android device. */
export function isPayzheBtpEligible(): boolean {
  return getPlatform() === 'android';
}

/** @deprecated Use isPayzheBtpEligible — bootstrap applies to all Android on-device browsers. */
export function shouldBootstrapPayzheBtpOnMobile(): boolean {
  return isPayzheBtpEligible();
}

export function buildPayzheBtpIntentUrl(): string {
  return PAYZHE_BTP_DEEP_LINK;
}

function navigateToUrl(url: string): void {
  if (typeof document !== 'undefined') {
    const anchor = document.createElement('a');
    anchor.href = url;
    anchor.style.display = 'none';
    document.body.appendChild(anchor);
    anchor.click();
    anchor.remove();
    return;
  }
  globalThis.location.href = url;
}

export function wakePayzheBtpApp(): void {
  if (!isPayzheBtpEligible()) return;
  try {
    navigateToUrl(PAYZHE_BTP_DEEP_LINK);
  } catch {
    /* ignore */
  }
}

export function sleep(ms: number): Promise<void> {
  return new Promise((resolve) => {
    globalThis.setTimeout(resolve, ms);
  });
}

export async function wakePayzheBtpAppAndWait(
  options: { attempts?: number; waitMs?: number } = {},
): Promise<void> {
  const attempts = options.attempts ?? 3;
  const waitMs = options.waitMs ?? 1_500;
  for (let i = 0; i < attempts; i += 1) {
    wakePayzheBtpApp();
    await sleep(waitMs);
  }
}
